<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "EximBilling",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  